import '../styles/global.css'
import { useRouter } from 'next/router'
import type { AppProps } from 'next/app'
import { StoreProvider } from 'easy-peasy'
import { useEffect } from 'react'
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react'

import { Loader } from '../components'
import Layout from '../components/Layout/Layout'
import { rollbarConfig } from '@libs/clients/ui-rollbar'
import store, { useStoreState, useStoreActions } from '../store'

function AuthWrapper({ children }) {
  const { isAuthenticated } = useStoreState(state => state.auth)
  const { loginWithRedirect, initialize } = useStoreActions(
    actions => actions.auth
  )
  const router = useRouter()

  useEffect(() => {
    initialize().then(() => {
      if (!isAuthenticated) {
        loginWithRedirect({ path: router.pathname })
      }
    })
  }, []) // Empty dependency array to run only once after component has mounted

  if (!isAuthenticated) {
    return <Loader show tip="Checking BAP Session..." />
  }

  return children
}

export default function App({ Component, pageProps }: AppProps) {
  return (
    <StoreProvider store={store}>
      <RollbarProvider config={rollbarConfig}>
        <ErrorBoundary>
          <AuthWrapper>
            <Layout>
              <Component {...pageProps} />
            </Layout>
          </AuthWrapper>
        </ErrorBoundary>
      </RollbarProvider>
    </StoreProvider>
  )
}
